import client from '../client';
import uuid from 'uuid';
import uploadVideoToS3 from '../common/utils/uploadVideoToS3';

export const ADD_TV_SHOW = 'ADD_TV_SHOW';
export const ADD_TV_EPISODE = 'ADD_TV_EPISODE';
export const ADD_VIDEO_TO_EPISODE = 'ADD_VIDEO_TO_EPISODE';
export const DELETE_TV_SHOW = 'DELETE_TV_SHOW';
export const DELETE_TV_EPISODE = 'DELETE_TV_EPISODE';
export const EDIT_TV_SHOW = 'EDIT_TV_SHOW';
export const EDIT_TV_EPISODE = 'EDIT_TV_EPISODE';
export const FETCH_TV_SHOWS = 'FETCH_TV_SHOWS';
export const FETCH_TV_EPISODES = 'FETCH_TV_EPISODES';
export const GET_TV_EPISODE_VIDEO = 'GET_TV_EPISODE_VIDEO';
export const UPLOAD_TV_EPISODE_VIDEO = 'UPLOAD_TV_EPISODE_VIDEO';
export const UPLOAD_TV_EPISODE_VIDEO_PROGRESS = 'UPLOAD_TV_EPISODE_VIDEO_PROGRESS';

export function fetchTvShows() {
  return {
    type: FETCH_TV_SHOWS,
    promise: client.get('tv-shows/all'),
  };
}

export function fetchTvEpisodes(showId) {
  return {
    type: FETCH_TV_EPISODES,
    promise: client.get(`tv-shows/${showId}/episodes/all`),
  };
}

export function addShow(values) {
  return {
    type: ADD_TV_SHOW,
    promise: client.post('tv-shows', values),
  };
}

export function addEpisode(showId, values) {
  return {
    type: ADD_TV_EPISODE,
    promise: client.post(`tv-shows/${showId}/episodes`, values),
  };
}

export function getEpisodeVideo(showId, episodeId) {
  return {
    episodeId,
    type: GET_TV_EPISODE_VIDEO,
    promise: client.get(`tv-shows/${showId}/episodes/${episodeId}/video`, null, {
      credentials: 'include', // Required for browser to respect Set-Cookie headers
    }),
  };
}

export function editShow(id, values) {
  const data = new FormData();
  if (values.image_id) data.append('image_id', values.image_id);
  if (values.image) data.append('image', values.image, uuid.v4());
  data.append('name', values.name);
  data.append('description', values.description);

  return {
    type: EDIT_TV_SHOW,
    promise: client.put(`tv-shows/${id}`, data),
  };
}

export function editEpisode(showId, episodeId, values) {
  const data = new FormData();
  if (values.image_id) data.append('image_id', values.image_id);
  if (values.image) data.append('image', values.image, uuid.v4());
  data.append('name', values.name);
  data.append('description', values.description);
  data.append('publish_at', values.publish_at);

  return {
    type: EDIT_TV_EPISODE,
    promise: client.put(`tv-shows/${showId}/episodes/${episodeId}`, data),
  };
}

export function deleteShow(id) {
  return {
    type: DELETE_TV_SHOW,
    promise: client.delete(`tv-shows/${id}`),
    id,
  };
}

export function deleteEpisode(showId, episodeId) {
  return {
    type: DELETE_TV_EPISODE,
    promise: client.delete(`tv-shows/${showId}/episodes/${episodeId}`),
  };
}

export function addVideoToEpisode(showId, episodeId, key) {
  return {
    type: ADD_VIDEO_TO_EPISODE,
    promise: client.post(`tv-shows/${showId}/episodes/${episodeId}/video`, { key }),
  };
}

export function updateUploading(uploading) {
  return {
    type: UPLOAD_TV_EPISODE_VIDEO,
    uploading,
  };
}

export function updateUploadProgress(loaded, total) {
  return {
    type: UPLOAD_TV_EPISODE_VIDEO_PROGRESS,
    loaded,
    total,
  };
}

export function uploadVideo(showId, episodeId, file) {
  return dispatch => {
    dispatch(updateUploading(true));

    return uploadVideoToS3(dispatch, file, updateUploadProgress)
      .then(data => dispatch(addVideoToEpisode(showId, episodeId, data.Key)))
      .then(() => dispatch(getEpisodeVideo(showId, episodeId)))
      .then(() => {
        dispatch(updateUploading(false));
        dispatch(updateUploadProgress(0, 100));
      });
  };
}



// WEBPACK FOOTER //
// ./src/tv/actions.js